import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-66090d1e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header-left" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text" }, "VOCs治理设施运维平台")
], -1))
const _hoisted_3 = { class: "header-center flex-mid-mid" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "header-right overflow" }
const _hoisted_6 = { class: "header-right-box1 overflow" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header-right-box2" }, null, -1))
const _hoisted_8 = { class: "header-right-box3 overflow" }

import { userInfo } from '@/api/userInfo'
import { userLogin } from '@/api/userLogin'
import $bus from '@/bus/index'
import { USER_TYPE_STATION_USER } from '@/constants/AccountCenter/index'
import { useUserinfoStore } from '@/store/userInfo'
import { goEnterprise } from '@/utils/common'
import { ElMessage } from 'element-plus'
import { Ref, onMounted, reactive, ref, watch } from 'vue'
import { useRouter } from 'vue-router'
interface navItem {
    title: string
    path: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderView',
  setup(__props) {

const userinfoStore = useUserinfoStore()
const router = useRouter()
const userData = reactive({
    comapny: '',
    name: '',
})
let activeIndex = ref(0)

onMounted(async () => {
    $bus.on('upUserInfo', () => {
        getUserInfo()
    })
    getUserInfo()
    await userinfoStore.getUserinfo()
    //  如果不是任意一个的管理员则不显示运维中心
    if (userinfoStore.userInfo.type === USER_TYPE_STATION_USER && (!userinfoStore.userInfo.station_role || userinfoStore.userInfo.station_role?.every(a => a.role === 2))) {
        let index = tabArr.value.findIndex(item => item.title === '运维中心')
        tabArr.value.splice(index, 1)
        if (router.currentRoute.value.path.includes('/operationCenter')) {
            ElMessage.error('暂无权限')
            setTimeout(() => {
                router.push({
                    path: tabArr.value[0].path,
                })
            }, 500)
        }
    }
})
const getUserInfo = () => {
    userInfo('indexUserInfo').then(res => {
        Object.assign(userData, res.data)
        localStorage.setItem('company', res.data.comapny)
        localStorage.setItem('name', res.data.name)
    })
}

const handleCommand = (command: string) => {
    if (command === 'logout') {
        userLogin('logout').then(() => {
            localStorage.removeItem('token')
            router.push({
                path: '/login',
            })
        })
    } else if (command === 'check') {
        // 跳转至企业端
        const token = localStorage.getItem('token') || ''
        goEnterprise(token)
    } else if (command === 'accountCenter') {
        router.push({
            path: '/accountCenter',
        })
    }
}
const tabArr: Ref<navItem[]> = ref([
    {
        title: '监测中心',
        path: '/monitoringCenter',
    },
    {
        title: '运维中心',
        path: '/operationCenter',
    },
    {
        title: '客户中心',
        path: '/customerCenter',
    },
    // {
    //   title: "图纸管理中心",
    //   path: "/admin",
    // },
])
const clickItem = (item: navItem, index: number) => {
    activeIndex.value = index
    router.push({
        path: item.path,
    })
}
const findActiveIndex = (path: string) => {
    return tabArr.value.findIndex((item: navItem) => {
        return path.includes(item.path)
    })
}
watch(
    () => router.currentRoute.value.path,
    newValue => {
        activeIndex.value = findActiveIndex(newValue)
    },
    {
        immediate: true,
    }
)

return (_ctx: any,_cache: any) => {
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabArr.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["header-center-nav1", { active: index === _unref(activeIndex) }]),
          onClick: ($event: any) => (clickItem(item, index)),
          key: index
        }, _toDisplayString(item.title), 11, _hoisted_4))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, _toDisplayString(userData.comapny), 1),
      _hoisted_7,
      _createVNode(_component_el_dropdown, {
        trigger: "click",
        onCommand: handleCommand
      }, {
        dropdown: _withCtx(() => [
          _createVNode(_component_el_dropdown_menu, null, {
            default: _withCtx(() => [
              (_unref(userinfoStore).userInfo.authorize_systems?.includes(2))
                ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                    key: 0,
                    command: "check"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("切换系统")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_el_dropdown_item, { command: "accountCenter" }, {
                default: _withCtx(() => [
                  _createTextVNode("账户中心")
                ]),
                _: 1
              }),
              _createVNode(_component_el_dropdown_item, { command: "logout" }, {
                default: _withCtx(() => [
                  _createTextVNode("退出登录")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_8, _toDisplayString(userData.name), 1)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})